<template>
  <div class="page mypage password_update pt-3">
    <p>現在お使いのメールアドレスを変更します。</p>
    <div class="mypage__body general-form">
      <form>
        <validation-observer v-slot="observer">
          <div class="general-form__group form-group mt-3 mt-md-4">
            <label
              for="inputPassword1"
              class="col-form-label">変更後のメールアドレス</label>
            <validation-provider   
              v-slot="v" 
              name="メールアドレス"
              rules="email|required">
              <b-form-input
                v-model="email"
                type="email"
                placeholder="sample@t-today.jp" />
              <p class="text-primary">
                {{ v.errors[0] }}
              </p>
            </validation-provider>
          </div>
          <div class="general-form__btn row mt-5">
            <div class="col-6">
              <router-link
                to="/settings/">
                <button
                  type="button"
                  class="btn btn-block btn-cancel">
                  キャンセル
                </button>
              </router-link>
            </div>
            <div class="col-6">
              <button
                type="button"
                class="btn btn-block btn-primary"
                @click="observer.passes(onClickSave)">
                保存
              </button>
            </div>
          </div>
        </validation-observer>
      </form>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      email: ''
    }
  },
  methods: {
    async onClickSave() {
      this.$store.commit('startLoading')
      this.$axios.patch('/accounts/me/', {email: this.email}).then(() => {
        this.$store.commit('notify/set', {message: '保存しました。'})
        this.$router.push('/settings/')
      }).catch((e) => {
        console.error(e)
        this.$store.commit('notify/set', {isUnknownError: true, type: 'danger'})
      }).finally(() => {
        this.created()
        this.$store.commit('finishLoading')
      })
    }, 
  }
}
</script>

<style lang="scss" scoped>
.mypage{
  &__head{
    background-color: $primary;
    color: $white;
    border-radius: 8px;
  }
  &__img{
    object-fit: cover; 
    width: 60px;
    height: 60px;
    max-width: 60px;
    
  }
  &__name{
    font-weight: bold;
  }
  &__title{
    font-size: $fs-s;
    line-height: 150%;
    font-weight: bold;
  }
  &__team{
    font-size: $fs-s;
    line-height: 150%;
    font-weight: bold;
  }
}

.form-info{
  color: $grey09;
  &__logout{
    text-decoration: none;
    font-weight: bold;
    color: $grey09;
    font-size: $fs-m;
  }
  &__date{
    font-size: $fs-m;
  }
}
</style>